module.exports = __webpack_public_path__ + "static/media/not-created.355d8132.png";